import React from 'react'
import { ClipLoader } from 'react-spinners'

// Spinner da mostrare durante i caricamenti
export default function Spinner() {
  return (   
        <ClipLoader 
            color={"#36d7b7"}
            loading={true}                  
            size={50}
            speedMultiplier={1}
            aria-label="Loading Spinner"
            data-testid="loader"
            cssOverride={{position: "absolute", left: "50vw", top: "50vh"}}
        />  
  )
}
